import {
  ChallengeTimelineItemType,
  IChallengeTimelineItem,
} from 'features/challenge/ChallengeTimelineItem';
import { IChallenge } from 'features/challenge/config/types';
import { useEditChallengesMutation } from 'features/challenge/hooks/mutation/useEditChallenges';

import { usePlanningBacklogQueryActions } from './query/backlog/useBacklogActions';
import { useOpenChallengeDialog } from './useOpenChallengeDialog';

type TUseOpenEditBacklogChallengeDialog = {
  challenge: IChallenge | ChallengeTimelineItemType;
};

export const useOpenEditBacklogChallengeDialog = ({
  challenge,
}: TUseOpenEditBacklogChallengeDialog) => {
  const { invalidateBacklogQuery } = usePlanningBacklogQueryActions();

  const { mutateAsync: editChallenge } =
    useEditChallengesMutation<IChallengeTimelineItem>({
      options: {
        onSuccess: async () => {
          invalidateBacklogQuery();
        },
      },
    });

  const openChallengeModal = useOpenChallengeDialog();

  return openChallengeModal({
    onChallengeSubmit: (challenge: IChallengeTimelineItem | IChallenge) =>
      editChallenge({ challenges: [challenge as IChallengeTimelineItem] }),
    challenge,
  });
};
